import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./Classes.css";

const GRADIENTS = [
  "linear-gradient(135deg,#667eea,#764ba2)",
  "linear-gradient(135deg,#f093fb,#f5576c)",
  "linear-gradient(135deg,#4facfe,#00f2fe)",
  "linear-gradient(135deg,#43e97b,#38f9d7)",
  "linear-gradient(135deg,#f7971e,#ffd200)",
  "linear-gradient(135deg,#11998e,#38ef7d)",
  "linear-gradient(135deg,#fa709a,#fee140)",
  "linear-gradient(135deg,#3a7bd5,#00d2ff)",
  "linear-gradient(135deg,#a18cd1,#fbc2eb)",
  "linear-gradient(135deg,#ff5f6d,#ffc371)",
];

export default function ClassList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [renameId, setRenameId] = useState(null);
  const [renameValue, setRenameValue] = useState("");

  const loadClasses = async () => {
    try {
      const res = await API.get("/school-admin/classes/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setClasses(res.data.classes || []);
      setFiltered(res.data.classes || []);
    } catch (err) {
      console.error("Error loading classes", err);
    }
  };

  useEffect(() => { loadClasses(); }, []);

  const archiveClass = async (id) => {
    if (!window.confirm("Archive this class and all students?")) return;
    try {
      await API.post(`/school-admin/classes/${id}/archive/`, {}, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      loadClasses();
    } catch {
      alert("Error archiving class");
    }
  };

  const openRenameModal = (id, name) => { setRenameId(id); setRenameValue(name); };
  const closeRenameModal = () => { setRenameId(null); setRenameValue(""); };

  const renameClass = async () => {
    if (!renameValue.trim()) return alert("Enter a new class name");
    try {
      await API.post(`/school-admin/classes/${renameId}/rename/`, { name: renameValue }, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      closeRenameModal();
      loadClasses();
    } catch {
      alert("Error renaming class");
    }
  };

  const handleSearch = (text) => {
    setSearchText(text);
    setFiltered(!text.trim() ? classes : classes.filter(c =>
      c.name.toLowerCase().includes(text.toLowerCase())
    ));
  };

  return (
    <div className="cl-page">

        {/* HERO */}
        <div className="cl-hero">
          <div className="cl-hero-left">
            <span className="cl-hero-icon">🏛️</span>
            <div>
              <h1 className="cl-hero-title">Classes</h1>
              <p className="cl-hero-sub">{classes.length} classes • {filtered.length} shown</p>
            </div>
          </div>
          <div className="cl-hero-actions">
            <button className="cl-btn-ghost" onClick={() => navigate("/school-admin/classes/archived")}>
              📦 Archived
            </button>
            <button className="cl-btn-white" onClick={() => navigate("/school-admin/classes/add")}>
              + Add Class
            </button>
          </div>
        </div>

        {/* SEARCH */}
        <div className="cl-search-wrap">
          <span className="cl-search-ico">🔍</span>
          <input
            type="text"
            placeholder="Search classes..."
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
          />
          {searchText && (
            <button className="cl-clear" onClick={() => handleSearch("")}>✕</button>
          )}
        </div>

        {/* GRID */}
        {filtered.length === 0 ? (
          <div className="cl-empty">
            <div className="cl-empty-icon">🏛️</div>
            <p>No classes found</p>
            <button className="cl-btn-white-outline" onClick={() => navigate("/school-admin/classes/add")}>
              + Add First Class
            </button>
          </div>
        ) : (
          <div className="cl-grid">
            {filtered.map((c, i) => (
              <div
                key={c.id}
                className="cl-card"
                style={{ background: GRADIENTS[i % GRADIENTS.length] }}
              >
                <span className="cl-card-bg-icon">🏛️</span>
                <p className="cl-card-num">#{i + 1}</p>
                <p className="cl-card-name">{c.name}</p>
                <div className="cl-card-btns">
                  <button className="cl-btn-rename" onClick={() => openRenameModal(c.id, c.name)}>
                    ✏ Rename
                  </button>
                  <button className="cl-btn-archive" onClick={() => archiveClass(c.id)}>
                    📦
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* RENAME MODAL */}
        {renameId && (
          <div className="cl-overlay" onClick={closeRenameModal}>
            <div className="cl-modal" onClick={(e) => e.stopPropagation()}>
              <div className="cl-modal-icon">✏️</div>
              <h3 className="cl-modal-title">Rename Class</h3>
              <input
                className="cl-modal-input"
                type="text"
                value={renameValue}
                onChange={(e) => setRenameValue(e.target.value)}
                placeholder="New class name"
                autoFocus
                onKeyDown={(e) => e.key === "Enter" && renameClass()}
              />
              <div className="cl-modal-row">
                <button className="cl-modal-cancel" onClick={closeRenameModal}>Cancel</button>
                <button className="cl-modal-save" onClick={renameClass}>Save Changes</button>
              </div>
            </div>
          </div>
        )}

      </div>
  );
}
